import { pxToRem } from '../../../utils/styles';
import { TypographyDevice } from '../_declarations/typography';
import fonts from './fonts';

const typography: TypographyDevice = {
  desktop: {
    bodyBold: {
      fontFamily: `'${fonts.secondary.bold.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    bodyInteractive: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('24px'),
      textDecorationLine: 'underline'
    },
    bodyLBold: {
      fontFamily: `'${fonts.secondary.bold.name}'`,
      fontSize: pxToRem('20px'),
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    bodyLRegular: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('20px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },

    // Body
    bodyRegular: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    bodySBold: {
      fontFamily: `'${fonts.secondary.bold.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: pxToRem('16px')
    },
    bodySDiscount: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('16px'),
      textDecorationLine: 'line-through'
    },
    bodySInteractive: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('16px'),
      textDecorationLine: 'underline'
    },
    bodySRegular: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('16px')
    },
    bodyXSRegular: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('10px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('11px')
    },
    breadcrumbRegular: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('20px')
    },
    breadcrumbUnderlined: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('20px'),
      textDecorationLine: 'underline'
    },
    // Heading
    heading1: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('64px'),
      fontWeight: 500,
      letterSpacing: '-0.04em',
      lineHeight: pxToRem('72px')
    },
    heading2: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('48px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('56px')
    },
    heading2Functional: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('24px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('32px')
    },
    heading2Impact: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('64px'),
      fontWeight: 500,
      letterSpacing: '-0.03em',
      lineHeight: pxToRem('72px')
    },
    heading3: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('32px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('40px')
    },
    heading4: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('24px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('32px')
    },
    heading5: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('20px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    heading6: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('18px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    heading7: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0.02em',
      lineHeight: pxToRem('24px')
    },
    heading8: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 500,
      letterSpacing: '0.02em',
      lineHeight: pxToRem('18px')
    },
    initials: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('48px'),
      fontWeight: 700,
      letterSpacing: '-0.09em',
      lineHeight: pxToRem('24px')
    },
    initialsSmall: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 362,
      letterSpacing: '-0.1em',
      lineHeight: pxToRem('24px')
    },

    // Price font (MVP)
    priceMedium: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0.02em',
      lineHeight: pxToRem('24px')
    },
    priceSmall: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('14px'),
      fontWeight: 500,
      letterSpacing: '0.02em',
      lineHeight: pxToRem('18px')
    },

    // Interactive Item
    textLinkRegular: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('20px')
    },
    textLinkUnderlined: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('20px'),
      textDecorationLine: 'underline'
    }
  },

  mobile: {
    bodyBold: {
      fontFamily: `'${fonts.secondary.bold.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    bodyInteractive: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('24px'),
      textDecorationLine: 'underline'
    },
    bodyLBold: {
      fontFamily: `'${fonts.secondary.bold.name}'`,
      fontSize: pxToRem('20px'),
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    bodyLRegular: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('20px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },

    // Body
    bodyRegular: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    bodySBold: {
      fontFamily: `'${fonts.secondary.bold.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: pxToRem('16px')
    },
    bodySDiscount: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('16px'),
      textDecorationLine: 'line-through'
    },
    bodySInteractive: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('16px'),
      textDecorationLine: 'underline'
    },
    bodySRegular: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('16px')
    },
    bodyXSRegular: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('9px'),
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: pxToRem('10px')
    },
    breadcrumbRegular: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('20px')
    },
    breadcrumbUnderlined: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('20px'),
      textDecorationLine: 'underline'
    },
    // Heading
    heading1: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('32px'),
      fontWeight: 500,
      letterSpacing: '-0.04em',
      lineHeight: pxToRem('40px')
    },
    heading2: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('24px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('32px')
    },
    heading2Functional: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('18px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    heading2Impact: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('32px'),
      fontWeight: 500,
      letterSpacing: '-0.04em',
      lineHeight: pxToRem('40px')
    },
    heading3: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('22px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('32px')
    },
    heading4: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('18px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    heading5: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('24px')
    },
    heading6: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('15px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('16px')
    },
    heading7: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('14px'),
      fontWeight: 500,
      letterSpacing: '0.02em',
      lineHeight: pxToRem('16px')
    },
    heading8: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('12px'),
      fontWeight: 500,
      letterSpacing: '0.02em',
      lineHeight: pxToRem('18px')
    },
    initials: {
      fontFamily: `'${fonts.secondary.normal.name}'`,
      fontSize: pxToRem('48px'),
      fontWeight: 700,
      letterSpacing: '-0.09em',
      lineHeight: pxToRem('24px')
    },
    initialsSmall: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 362,
      letterSpacing: '-0.1em',
      lineHeight: pxToRem('24px')
    },

    // Price font (MVP)
    priceMedium: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0.02em',
      lineHeight: pxToRem('24px')
    },
    priceSmall: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('14px'),
      fontWeight: 500,
      letterSpacing: '0.02em',
      lineHeight: pxToRem('18px')
    },

    // Interactive Item
    textLinkRegular: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('20px')
    },
    textLinkUnderlined: {
      fontFamily: `'${fonts.primary.normal.name}'`,
      fontSize: pxToRem('16px'),
      fontWeight: 500,
      letterSpacing: '0',
      lineHeight: pxToRem('20px'),
      textDecorationLine: 'underline'
    }
  }
};

export default typography;
